module.exports = __webpack_public_path__ + "img/itsm-maritech.7eb517c9.jpg";